<template>
  <div class="date-picker">
    <el-date-picker
      v-if="use_config"
      v-model="date"
      :type="use_config.type"
      align="right"
      size="mini"
      unlink-panels
      :value-format="use_config.value_format"
      range-separator="至"
      :start-placeholder="use_config.start_placeholder"
      :end-placeholder="use_config.end_placeholder"
      :picker-options="use_config.pickerOptions"
      class="chose-date"
      @change="changeDate"
    />
  </div>
</template>

<script>
export default {
  props: {
    // 绑定日期数据
    data: {
      type: Array,
      default: () => {
        return [new Date(), new Date()];
      },
    },
    // 显示类型
    type: { type: String, default: 'daterange' },
  },
  data() {
    return {
      date: this.data,
      use_config: null,
      config: [
        {
          type: 'daterange',
          value_format: 'yyyy-MM-dd',
          start_placeholder: '开始日期',
          end_placeholder: '结束日期',
          pickerOptions: {
            shortcuts: [{
              text: '最近一周',
              onClick: (picker) => {
                picker.$emit('pick', this.getTimeDay(7));
              },
            }, {
              text: '最近一个月',
              onClick: (picker) => {
                picker.$emit('pick', this.getTimeDay(30));
              },
            }, {
              text: '最近三个月',
              onClick: (picker) => {
                picker.$emit('pick', this.getTimeDay(90));
              },
            }],
          },
        },

        {
          type: 'monthrange',
          value_format: 'yyyy-MM',
          start_placeholder: '开始月份',
          end_placeholder: '结束月份',
          pickerOptions: {
            shortcuts: [{
              text: '本月',
              onClick(picker) {
                picker.$emit('pick', [new Date(), new Date()]);
              },
            }, {
              text: '今年至今',
              onClick(picker) {
                const end = new Date();
                const start = new Date(new Date().getFullYear(), 0);
                picker.$emit('pick', [start, end]);
              },
            }, {
              text: '最近六个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setMonth(start.getMonth() - 6);
                picker.$emit('pick', [start, end]);
              },
            }],
          },

        },
      ],
    };
  },
  created(){
    // 根据类型判断用哪个配置
    this.use_config = this.config.filter(item => item.type === this.type)[0];
  },
  methods: {
    changeDate(){
      this.$emit('change', this.date);
    },

    /**
     * 以天数为维度获取开始和结束时间
     * @param day  天数
     */
    getTimeDay(day){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * day);
      return [start, end];
    },
  },
};
</script>

<style scoped>
.date-picker{
  display: inline-block;
}
.chose-date{
  margin-right: 10px;
}
</style>
